/** Update or create `<link rel="canonical">` in the document head. */
export function setCanonicalLinkHref(document: Document, href: string): void {
  let link = document.getElementById('canonical-link') as HTMLLinkElement | null;
  if (!link) {
    link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  }
  if (!link) {
    link = document.createElement('link');
    link.id = 'canonical-link';
    link.rel = 'canonical';
    document.head.appendChild(link);
  }
  link.href = href;
}
